import {useMemo} from "react";
import {Text, ThemeIcon} from "@mantine/core";

type LinkProps = {
    reference: string;
};
export const Citation = ({reference}: LinkProps) => {
    const number = useMemo(() => {
        const number = reference.replace(/[\[\]]/g, "");
        try {
            parseInt(number);
            return number;
        } catch (e) {
            console.error("Invalid reference number");
            return null;
        }
    }, [reference]);

    const numberPlusOne = useMemo(() => {
        if (!number) {
            return null;
        }
        return parseInt(number) + 1;
    }, [number]);

    if (!number) {
        return null;
    }

    return (
        <ThemeIcon
            className="citation-badge"
            component={"span"}
            size="xs"
            radius="xl"
            variant="light"
            color="gray"
            w="1rem"
            h="1rem"
            mx="1px"
        >
            <Text span fz="xs" c="gray.7">
                {numberPlusOne}
            </Text>
        </ThemeIcon>
    );
};
